import { ITranslation } from "../typings/languageFragmentsTranslation";

export class LanguageFragmentsTranslation {
    private static _instance: LanguageFragmentsTranslation;

    private constructor() {
        const scriptElement: HTMLElement = document.getElementById('translated-page-urls');

        if (scriptElement && scriptElement.innerText) {
            this.appendTranslatedPageUrls(scriptElement);
        }
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    private appendTranslatedPageUrls(scriptElement: HTMLElement): void {
        const translations: ITranslation[] = JSON.parse(scriptElement.innerText).translations;
        const dlpNavigationKey: HTMLElement = document.querySelector('.scope-dlp');

        // decode urls and append url:
        for (const translation of translations) {
            let decodedUrl: string;

            if (translation.obfuscation === 'l10n') {
                // no further actions are needed:
                return;
            }
            else {
                // append url with dlp key, usually needed for preview from editor:
                decodedUrl =  window.atob(translation.url);

                if(dlpNavigationKey.dataset.dlpnavigationkey)
                    decodedUrl += '/' + dlpNavigationKey.dataset.dlpnavigationkey;
            }

            const url = window.btoa(decodedUrl);

            translation.url = url;
        }

        const result = { translations: translations };

        scriptElement.innerText = JSON.stringify(result);
    }
}

LanguageFragmentsTranslation.instance;
